import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AttributeOption, Scope } from '@app/shared/interfaces/Attribute';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { Subject, takeUntil } from 'rxjs';
import { AttributeTypes } from 'src/global-variables';

@Component({
  selector: 'app-attribute-default-value',
  templateUrl: './attribute-default-value.component.html',
  styles: [],
})
export class AttributeDefaultValueComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;
  @Input() set options(options: AttributeOption[]) {

    this.dropDownMeta['DefaultValue'] = options.map((option) => {
      return {
        Code: option.Id,
        Label: option.Name,
      };
    });
  }

  dropDownMeta: { [key: string]: any[] } = {};
  destroySubject$ = new Subject<void>();
  field: ModelField = {
    Code: 'DefaultValue',
    Title: 'Default Value',
    Scope: Scope.Global,
    DataType: AttributeTypes.String,
  };
  constructor() {}

  ngOnInit(): void {
    const value = this.formGroup.getRawValue();
    if (value.Type != null) {
      this.field.DataType = value.Type;
    }
  //  console.log('ngOnInit ~ value:', value);
    this.formGroup.valueChanges
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((formValue) => {
        //console.log('ngOnInit ~ formValue:', formValue);
      });
  }
  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
